import { render, staticRenderFns } from "./HeadCards.vue?vue&type=template&id=5c0e5bd8&scoped=true&"
import script from "./HeadCards.vue?vue&type=script&lang=js&"
export * from "./HeadCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0e5bd8",
  null
  
)

export default component.exports